<template>
    <div>
        <div class="flex flex-col md:flex-row md:justify-between">
            <div class="flex">
                <h1 class="text-3xl">Configuraciones</h1>
            </div>
        </div>
        <div class="flex flex-wrap mt-3">
            <div class="w-1/2 md:w-4/12 my-3 flex">
                <div class="mr-4">
                    <span> Tema </span>
                </div>
                <div class="w-1/2">
                    <change-theme />
                </div>
            </div>

            <div class="w-1/2 md:w-4/12 my-3 flex">
                <div class="mr-4">
                    <span> Sonidos activados </span>
                </div>
                <div class="w-1/2">
                    <change-sound />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChangeSound from "@/components/layout/ChangeSound.vue";
import ChangeTheme from "@/components/layout/ChangeTheme.vue";

export default {
    name: "ConfigurationsPage",
    components: {
        ChangeSound,
        ChangeTheme
    },
    layout: "app",
    data: () => ({}),
    computed: {},
    watch: {},
    async mounted() {},
    methods: {}
};
</script>
